import { Image, ImageProps } from 'theme-ui'

const Stader = (props: ImageProps) => {
  return <Image width={16} src="/svgs/stader.svg" {...props} />
}
export default Stader
